import { render, staticRenderFns } from "./Corpuslist.vue?vue&type=template&id=73627c89"
import script from "./Corpuslist.vue?vue&type=script&lang=js"
export * from "./Corpuslist.vue?vue&type=script&lang=js"
import style0 from "./Corpuslist.vue?vue&type=style&index=0&id=73627c89&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1b3fe109433f9fe6108f2b5a977879df/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports